module.exports = __webpack_public_path__ + "img/content.766dd145.jpg";